<template>
  <section class="wrap">
    <div class="container-wrap observer-selector">
      <div class="title">
        배송의 시작부터 끝까지 <br />
        디버와 함께해요
      </div>
      <div class="content">
        <div class="step-img">
          <img
            class="only-desktop"
            :src="require(`@/assets/img/home/step${hoverStep}.png`)"
          />
          <img
            class="only-mobile"
            :src="require(`@/assets/img/home/step${hoverStep}_m.png`)"
          />
        </div>
        <div class="description-wrap">
          <div
            v-for="(step, idx) in steps"
            class="step-description"
            :class="{ active: idx + 1 === hoverStep }"
            @mouseover="hoverStep = idx + 1"
          >
            <div class="number-tag">{{ idx + 1 }}</div>
            {{ step }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      steps: [
        "주문 접수 시 투명하고 정확한 요금 확인",
        "카드 등록 또는 월정산으로 3초만에 결제",
        "배송 파트너 실시간 위치 확인",
        "물품 픽업/배송 완료 사진 확인"
      ],
      hoverStep: 1
    };
  },
  methods: {}
};
</script>
<style src="../home.common.css" scoped />
<style scoped>
.content {
  display: flex;
  flex-direction: column-reverse;
  gap: 40px;
  margin-top: 40px;
}

.step-img {
  background-color: var(--gray-200);
  border-radius: 32px;
  max-height: 350px;
  display: flex;
  justify-content: center;
}

.step-description {
  padding: 16px;
  color: var(--gray-600);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.step-description.active {
  background-color: var(--primary-100);
  font-weight: 500;
  color: var(--primary-500);
  border-radius: 16px;
}

.step-description .number-tag {
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background-color: var(--gray-600);
  color: var(--white);
}

.step-description.active .number-tag {
  background-color: var(--primary-500);
}

img {
  max-width: 350px;
  width: 100%;
  height: auto;
}

.only-desktop {
  display: none;
}

.only-mobile {
  display: block;
}

@media (min-width: 1024px) {
  .content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: none;
    gap: 20px;
    margin-top: 56px;
  }

  .step-description {
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;
    padding: 0px 20px;
  }

  .only-desktop {
    display: block;
  }

  .only-mobile {
    display: none;
  }

  .step-img {
    height: 350px;
  }

  img {
    max-width: none;
    width: 100%;
    height: auto;
  }

  .description-wrap {
    display: grid;
  }
}
</style>
